var modal = (function() {
"use strict";

	var body		= $('body'),
		modal 		= $('.modal'),
		overlay 	= $('.overlay'),
		closeBtn 	= $('<button class="close">&times;</button>'),
		modalData;

	body.on('click', '.modaltrigger', openModal);
	body.on('click', '.modal .close, .modal .close-on-submit, .overlay', closeModal);
	body.on('keyup', closeModal);

	function openModal(e) {
		e.preventDefault();

		var top, source, template, html;
		modalData 	= $(this).data();
		modal.append(closeBtn);
		overlay.fadeIn(40);

		top = $(window).height() / 2 - modal.height() / 2 - 100;
		modal.css({top: top}).fadeIn(40);
	}

	function closeModal(e) {
		var dismiss = (modalData === undefined || modalData.dismiss === undefined || modalData.dismiss) ? true : false;

		// exit if data-dismiss is set to false or if any key other than escape is pressed
		if(!dismiss || e.type === 'keyup' && e.keyCode !== 27) return;

		e.preventDefault();

		modal.empty().hide();
		overlay.hide();
	}

})();
